import { constants } from "../constants/redux-constants";

const initialState = {
    isTokenExpired : false
};

const tokensReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_TOKEN_EXPIRED:
      return {
        ...state,
        isTokenExpired : action.payload,
      };
    default:
      return state;
  }
};

export default tokensReducer;
